import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ToastService } from '../../../../../projects/client/src/app/shared/services/toast.service';
import { setControlEnabled } from '../../utils/functions/set-control-enabled';
import * as R from 'ramda';

export abstract class SidepaneHost {
  sh: SidepaneHelper;
  form?: UntypedFormGroup;
  ngOnDestroy?: () => void;

  // TODO: provide id from route?
  spOnSubmit?: () => void;
}

export class SidepaneHelper {
  public toastService: ToastService;

  public isSubmitting = false;
  public destroy$ = new Subject();

  public goBack: () => void;

  constructor(private sidepaneHost: SidepaneHost) {}

  public get value() {
    return R.clone(this.sidepaneHost.form?.value);
  }

  public get valid() {
    return this.sidepaneHost.form?.valid;
  }

  public control(name: string): AbstractControl {
    return this.sidepaneHost.form?.get(name);
  }

  public enabled(name: string): boolean {
    return this.sidepaneHost.form?.get(name).enabled;
  }

  public setEnabled(name: string, enabled: boolean): void {
    const control = this.control(name);
    setControlEnabled(control, enabled);
  }
}
